import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/13Footer/FooterWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/14BlogsPage/BlogListing.jsx");
